import { selectRootSliceCLPW } from '../../Main/selectors';
import { ROOT_SLICE } from './constants';

const EMPTY_ARRAY = [];

export const selectThisSlice = state => { 
  const slice = selectRootSliceCLPW(state);
  if (slice[ROOT_SLICE]) { 
    return slice[ROOT_SLICE];
  }

  // else assume state is already lines aggs.
  return state;
};

export const selectMessagesByTopicMap = state => {
	const slice = selectThisSlice(state);
  	const { messagesByTopic } = slice;
	return messagesByTopic;
};

export const selectTopicMeta = (state, topic) => {
	const messagesByTopic = selectMessagesByTopicMap(state);
	return messagesByTopic[topic];
};

export const selectTopicMetaIsActive = (state, topic) => {
	const topicMeta = selectTopicMeta(state, topic);
	return !!topicMeta?.active;
};

export const selectMessages = (state, topic) => {
	const topicMeta = selectTopicMeta(state, topic);
	return topicMeta?.messages || EMPTY_ARRAY;
};

export const selectTopicMetaHasError = (state, topic) => {
	const messages = selectMessages(state, topic) || [];
	return messages.filter(m => m?.isError || m?.body?.isError).length > 0;
};

export default {
	selectThisSlice,
	selectMessagesByTopicMap,
	selectTopicMeta,
	selectMessages,
};
